export class User {
  userID!: number;
  username!: string;
  password!: string;
  xidResK!: string;
  xidWebK!: string;
  xidmfa!: boolean;
  firstName!: string;
  lastName!: string;
  statusCode!: string;
  roleID!: number;
  roleName!: string;
  lastLoginTime!: any; // change to any to accept euro format on display
  passwordAttempts!: number;
  passwordExpireTime: any; // change to any to accept euro format on display
  isPasswordExpired!: boolean;
  shipID!: number;
  shipName!: string;
  contactID!: number;
  createTime!: Date;
  createUserID!: number;
  updateTime!: Date;
  updateUserID!: number;
  isOrderHandler!: boolean;
  hasShipCrewContract!: boolean;
  userTypeID!: number;
}
